import React from "react";
// Header.jsx
export const Header = ({ data }) => (
  <header id="header">
    <div
      className="intro"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/img/intro-bg.jpg)`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="overlay" />
      <div className="container">
        <div className="intro-text">
          <h1>{data?.title ?? 'Hípica Madrid Campogrande'}</h1>
          <p>{data?.paragraph ?? 'Clases de equitación para todas las edades.'}</p>
          <a href="#features" className="btn btn-custom btn-lg page-scroll">Ver más</a>
        </div>
      </div>
    </div>
  </header>
);
